import React from "react";
import { Box, Card, CardContent, Divider, Typography, useTheme } from "@mui/material";
import { NarrativeTemplate } from "../../../shared/interfaces/ReportGenReport";
import { cardStyles, cardContentStyles, sectionHeaderStyles } from "../styles";
import { ReportTypeSelector } from "./ReportTypeSelector";
import { NarrativeExample } from "./NarrativeExample";
import { GenerateReportActions } from "./GenerateReportActions";

interface Props {
  reportType: NarrativeTemplate;
  reportTypes: NarrativeTemplate[];
  onReportTypeChange: (value: NarrativeTemplate) => void;
  onGenerate: () => void;
  isGenerating: boolean;
  isMaxJobsReached: boolean;
  generateDisabled: boolean;
  failedVideoCount: number;
  pendingVideoCount: number;
  viewedCount: number;
  totalVideos: number;
  onTranscribe: () => void;
  isTranscribing: boolean;
  transcribeDisabled: boolean;
  showTranscribeButton: boolean;
}

export const ReportConfigSection: React.FC<Props> = ({
  reportType,
  reportTypes,
  onReportTypeChange,
  onGenerate,
  isGenerating,
  isMaxJobsReached,
  generateDisabled,
  failedVideoCount,
  pendingVideoCount,
  viewedCount,
  totalVideos,
  onTranscribe,
  isTranscribing,
  transcribeDisabled,
  showTranscribeButton,
}) => {
  const theme = useTheme();

  return (
    <Card {...cardStyles(theme)} sx={{ ...cardStyles(theme).sx, height: "auto" }}>
      <CardContent {...cardContentStyles}>
        <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: "50%",
              bgcolor: theme.palette.primary.main,
              color: "white",
              fontWeight: 700,
              fontSize: "1rem",
              flexShrink: 0,
            }}
          >
            2
          </Box>
          <Typography {...sectionHeaderStyles(theme)}>Select Narrative Template</Typography>
        </Box>
        <Divider sx={{ mb: 3 }} />

        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 3 }}>
          <ReportTypeSelector
            reportType={reportType}
            reportTypes={reportTypes}
            onChange={onReportTypeChange}
          />

          <NarrativeExample example={reportType.examples?.[0]} />

          <GenerateReportActions
            onGenerate={onGenerate}
            isGenerating={isGenerating}
            isMaxJobsReached={isMaxJobsReached}
            generateDisabled={generateDisabled}
            failedVideoCount={failedVideoCount}
            pendingVideoCount={pendingVideoCount}
            viewedCount={viewedCount}
            totalVideos={totalVideos}
            onTranscribe={onTranscribe}
            isTranscribing={isTranscribing}
            transcribeDisabled={transcribeDisabled}
            showTranscribeButton={showTranscribeButton}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
